import { useMemo } from 'react';

import {
  useCurrentProductId,
  PRODUCT_IDS,
  ProductIdType,
  useCurrentProject,
  useCurrentToolId,
} from '@adsk/alloy-provider';

import { MeetingItem } from '../types';

export function useEntityLink(entity: MeetingItem) {
  const productId = useCurrentProductId() || PRODUCT_IDS.BUILD;
  const products = useCurrentProject()?.products;
  const toolId = useCurrentToolId() as string;
  const projectId = useCurrentProject()?.id;

  const projectUrl = useMemo(() => {
    const findUrlByProduct = (productId: ProductIdType) =>
      products
        ?.find((p) => p.key === productId)
        ?.tools?.find((t) => t.key === 'meetings')?.url;

    return findUrlByProduct(productId) ?? findUrlByProduct('build');
  }, [productId, products]);

  if (!projectId || !toolId) {
    console.error(
      'projectId or Tool ID is undefined! Meeting Item Ref Link might be broken.',
    );
  }

  return projectUrl
    ? // URL is absolute and is taken from current tool or from Build.
      `${projectUrl}/meeting/${entity.meeting.id}?item=${entity.id}&origin=${toolId}`
    : // Meetings doesn't exist in current tool AND user has no access to Build.
      // We redirect to `/build...` - Exo config should take it from here and redirect to MC / DC - note URL is relative.
      `/build/meetings/projects/${projectId}/meeting/${entity.meeting.id}?item=${entity.id}&origin=${toolId}`;
}
